import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import MobileUnderCalAds from "../../Ads"
const TITLE = "تحويل الحجم - أداة تحويل وحدات الحجم";
const DESCRIPTION =
  "حوّل وحدات الحجم المختلفة بدقة وسهولة باستخدام أداة تحويل الحجم. احصل على قياسات دقيقة بين اللترات والمتر المكعب والمزيد.";
const KEYWORDS =
  "تحويل الحجم, محول الحجم, تحويل اللترات, تحويل المتر المكعب, أدوات قياس الحجم, حاسبة تحويل الحجم";
const OG_URL = "https://do-calculate.com/calculator/ar/unit_converter/volume/";
const volumeParameters = {
  cubicm: "متر مكعب",
  cubickm: "كيلومتر مكعب",
  cubiccm: "سنتيمتر مكعب",
  cubicmm: "ميليمتر مكعب",
  liter: "لتر",
  milliliter: "مليلتر",
  usgallon: "جالون أمريكي",
  usquart: "ربع جالون أمريكي",
  uspint: "نصف لتر أمريكي",
  uscup: "كوب أمريكي",
  usfluidounce: "أونصة سائلة أمريكية",
  ustablespoon: "ملعقة كبيرة أمريكية",
  usteaspoon: "ملعقة صغيرة أمريكية",
  imperialgallon: "جالون إمبراطوري",
  imperialquart: "ربع جالون إمبراطوري",
  imperialpint: "نصف لتر إمبراطوري",
  imperialfluidounce: "أونصة سائلة إمبراطورية",
  imperialtablespoon: "ملعقة كبيرة إمبراطورية",
  imperialteaspoon: "ملعقة صغيرة إمبراطورية",
  cubicmile: "ميل مكعب",
  cubicyard: "ياردة مكعبة",
  cubicfoot: "قدم مكعب",
  cubicinch: "بوصة مكعبة",
};
const volumes = Object.keys(volumeParameters);
function UnitsList() {
  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };
  const renderTable = (parameters, parameterNames) => (
    <table >
      <thead>
        <tr>
          <th >من الوحدة</th>
          <th >إلى الوحدة</th>
          <th >رابط الحاسبة</th>
        </tr>
      </thead>
      <tbody>
        {parameters
          .filter((fromParams) =>
            parameterNames[fromParams].includes(searchTerm)
          )
          .map((fromParams) =>
            parameters.map((toParams) => {
              if (fromParams !== toParams) {
                const url = `/calculator/ar/unit_converter/volume/${fromParams}/${toParams}/`;
                return (
                  <tr key={`${fromParams}-${toParams}`}>
                    <td>{parameterNames[fromParams]}</td>
                    <td>{parameterNames[toParams]}</td>
                    <td>
                      <a href={url}>
                        تحويل من {parameterNames[fromParams]} إلى{" "}
                        {parameterNames[toParams]}
                      </a>
                    </td>
                  </tr>
                );
              }
              return null;
            })
          )}
      </tbody>
    </table>
  );
  return (
    <div>
      <div className="container rtl-container">
        <SharedHelmet
          TITLE={TITLE}
          DESCRIPTION={DESCRIPTION}
          KEYWORDS={KEYWORDS}
          OG_URL={OG_URL}
        />
        <div>
          <h1 style={{ fontSize: "26px" }}>{TITLE}</h1>
          <hr />
          <div className="alert alert-secondary" role="alert">
            <p>{DESCRIPTION}</p>
          </div>
        </div>
        <hr />
         <MobileUnderCalAds />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingBottom: "15px",
          }}
        >
          <h2 style={{ margin: 0 }}>الحجم</h2>
          <input
            type="text"
            placeholder="ابحث عن وحدة..."
            value={searchTerm}
            onChange={handleSearchChange}
            style={{
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              width: "200px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          />
        </div>
        {renderTable(volumes, volumeParameters)}
        <br />
      </div>
    </div>
  );
}
export default UnitsList;
